import { render, staticRenderFns } from "./TournamentsTable.vue?vue&type=template&id=396a2de5&"
import script from "./TournamentsTable.vue?vue&type=script&lang=js&"
export * from "./TournamentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports